import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import Highlighter from 'react-highlight-words';
export var HighlighterElement = styled(Highlighter)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .highlight {\n    background: rgb(255, 235, 179);\n    border-radius: 2px;\n    padding: 3px 0;\n  }\n"], ["\n  .highlight {\n    background: rgb(255, 235, 179);\n    border-radius: 2px;\n    padding: 3px 0;\n  }\n"])));
HighlighterElement.defaultProps = {
    highlightClassName: 'highlight',
};
var templateObject_1;
